var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "total"
  }, [_vm._v(" " + _vm._s(_vm.source.allKnowledge || 0) + " ")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };